<template>
  <div>
    <el-tabs v-model="activeName">
      <!-- <el-tab-pane
        v-for="(item,index) in tabList"
        :key="index"
        :label="item.label"
        :name="item.name"
      >
        <component
          :is="item.content"
          v-if="item.content"
        />
      </el-tab-pane> -->
      <el-tab-pane
        label="领取记录"
        name="collectRecord"
      >
        <CollectRecord v-if="activeName === 'collectRecord'" />
      </el-tab-pane>

      <el-tab-pane
        label="红包配置"
        name="redSetting"
      >
        <RedSetting v-if="activeName === 'redSetting'" />
      </el-tab-pane>

      <el-tab-pane
        label="操作日志"
        name="options"
      >
        <Options v-if="activeName === 'options'" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
export default {
  components: {
    'RedSetting': () => import('./redSetting'),
    'CollectRecord': () => import('./collectRecord'),
    'Options': () => import('./options')
  },
  data () {
    return {
      // tabList:[
      //   {
      //     label:'领取记录',
      //     name:'collectRecord',
      //     content:collectRecord
      //   },
      //   {
      //     label:'红包配置',
      //     name:'redSetting',
      //     content:redSetting
      //   },
      //   {
      //     label:'操作日志',
      //     name:'options',
      //     content:options
      //   }
      // ],

      activeName: 'collectRecord'
    }
  },
  mounted () {},
  methods: {}
}
</script>
